<template>
  <a
    v-if="type === 'external'"
    :aria-label="aria"
    :title="title"
    :href="utmHref(path, utm)"
    :tabindex="tabindex"
    :class="[`text-${textcolor}`]"
  >
    <span
      v-if="text"
      :class="[
        `text-${textsize}`,
        { 'order-2': iconleft, underline: underline }
      ]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </a>

  <button
    v-else-if="type === 'button'"
    :aria-label="aria"
    :title="title"
    :disabled="disabled"
    :tabindex="tabindex"
    :class="[`text-${textcolor}`]"
    @click="$emit('buttonClick')"
  >
    <span
      v-if="text"
      :class="[
        `text-${textsize}`,
        { 'order-2': iconleft, underline: underline }
      ]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </button>

  <RouterLink
    v-else
    :to="path"
    :aria-label="aria"
    :title="title"
    :append="append"
    :tabindex="tabindex"
    :class="[`text-${textcolor}`]"
  >
    <span
      v-if="text"
      :class="[`text-${textsize}`, { 'order-2': iconleft }]"
      v-html="text"
    />
    <IconBase
      v-if="icon"
      :icon="icon"
      :color="iconcolor"
      :size="iconsize"
      :rotate="iconrotation"
      :class="{ 'order-1 mr-2': iconleft, 'ml-2': iconright }"
    />
  </RouterLink>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'Button',

  components: {
    IconBase
  },

  props: {
    type: {
      type: String,
      default: ''
    },
    path: {
      type: [Object, String],
      default: '/'
    },
    append: {
      type: Boolean,
      default: false
    },
    utm: {
      type: String,
      default: 'tier-1-cta'
    },
    icon: {
      type: String,
      default: ''
    },
    iconsize: {
      type: String,
      default: '1.5rem'
    },
    iconcolor: {
      type: String,
      default: 'inherit'
    },
    iconleft: {
      type: Boolean,
      default: false
    },
    iconright: {
      type: Boolean,
      default: false
    },
    iconrotation: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textsize: {
      type: String,
      default: 'base'
    },
    textcolor: {
      type: String,
      default: 'inherit'
    },
    aria: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 0
    },
    underline: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([])
  }
}
</script>
